import { Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Toast} from 'app/shared/toast/toast';
import {IdexService} from 'app/idex.service';
import {MatLegacyAutocomplete as MatAutocomplete} from '@angular/material/legacy-autocomplete';
import {MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';

declare let $: any;
let message, message_dup, message_lang;

export interface Transaction {
   id: string;
   name: string;
}

@Component({
   selector: 'app-add-group-company',
   templateUrl: './add-group-company.component.html',
   styleUrls: ['./add-group-company.component.css']
})
export class AddGroupCompanyComponent implements OnInit {
   roles = [
      {value: 'Admin', viewValue: 'admin'},
      {value: 'Editor', viewValue: 'editor'},
      {value: 'Moderator', viewValue: 'moderator'},
      {value: 'Member', viewValue: 'member'}
   ];
   type_input: any;
   default_value = 'Member';
   contIdvalue = '';
   contactOpt: any;
   listGroup: any;
   show = true;
   oldName: any;
   tin: string;
   flagSubmit = false;
   permission: any;
   rowgroup: any;
   listUserSite: Contact[];
   groupNameValue: any;
   isAddGroup: any;
   contNamevalue = '';
   contEmailvalue = '';
   error_email = false;
   myControl = new FormControl();
   groupContvalue = '';
   members: Contact[] = [];
   filteredOptions: Observable<Contact[]>;
   errorMessage: string;
   requireInputMessage: string;
   disabled = true;
   checkBlur = true;
   checkRow = true;
   siteName: any;
   flagEdit = false;
   @ViewChild(MatAutocomplete) matAutocomplete: MatAutocomplete;
   @ViewChild('fullName') fullName: ElementRef;
   @ViewChild('fullName_add') fullName_add: ElementRef;
   fname_add = '';
   
   constructor(public toast: Toast,
               public service: IdexService,
               public translate: TranslateService,
               private dialogRef: MatDialogRef<AddGroupCompanyComponent>) {
   }

   ngOnInit() {
      if (this.isAddGroup) {
         this.getListGroup();
         this.disabled = false;
      }
      this.tin = localStorage.getItem('tin');
      this.service.get('/work/' + this.tin + '/team')
         .subscribe(
            data => {
               this.listUserSite = data;
            }
         );
      this.translate.get('alert.inputRequired').subscribe((msg) => {
         this.requireInputMessage = msg;
         message = msg;
      });
      this.translate.get('alert.not-match-group').subscribe((msg_dup) => {
         this.requireInputMessage = msg_dup;
         message_dup = msg_dup;
      });
      this.translate.get('alert.create_group_company').subscribe(msg_lang => {
         this.requireInputMessage = msg_lang;
         message_lang = msg_lang;
      });
   }

   getListGroup() {
      this.service.getCompanyGroup(this.tin)
         .subscribe(
            data => {
               this.listGroup = data;
            }
         );
   }

   onkeyup(item) {
      const reg = /^[_A-Za-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
      if (item.value.length === 0) {
         this.error_email = false;
         return;
      } else if (!reg.test(item.value)) {
         this.error_email = true;
         return;
      } else {
         this.error_email = false;
      }
   }

   cultivoChange(permission: any) {
      if (!this.isAddGroup) {
         this.flagEdit = true;
         const u = this.rowgroup.type === 'USER' ? 'true' : 'false';
         this.service.put('/work/' + this.tin + '/team/' + this.rowgroup.id + '/' + permission + '?u=' + u, {})
            .subscribe(() => {
               this.protectLast(this.listGroup);
            });
      }
   }

   protectLast(item: any) {
      let j = 0;
      for (let i = 0; i < item.length; i++) {
         if (item[i].role === 'Admin') {
            j++;
         }
      }
      if (j === 1) {
         this.show = false;
      } else {
         this.show = true;
      }
   }

   selectKeyPress(event, cont: any) {
      if (event.key === 'Enter') {
         return;
      }
      this.filteredOptions = this.myControl.valueChanges
         .pipe(
            startWith<string | Contact>(''),
            map(value => typeof value === 'string' ? value : value.name),
            map(name => name ? this.filter(name) : null)
         );
   }

   filter(keyword: string): any {
      return this.listUserSite.filter(transactions =>
         transactions.id.toLowerCase().indexOf(keyword.toLowerCase()) !== -1
         || transactions.name.toLowerCase().indexOf(keyword.toLowerCase()) !== -1);
   }

   highlightFirstOption(event): void {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
         return;
      }
      this.matAutocomplete._keyManager.setFirstItemActive();
   }

   selectContact(evt: any, contactOpt: any, cont: any): void {
      if (evt.source && evt.source.selected && cont.value !== '') {
         let isExist = false;
         for (let i = 0; i < this.members.length; i++) {
            if (this.members[i].id === contactOpt.value.id) {
               isExist = true;
               break;
            }
         }
         if (!isExist) {
            if (!this.isAddGroup) {
               this.flagEdit = true;
               this.service.addMemberGroup(this.rowgroup.id, contactOpt.value.id)
                  .subscribe();
            }
            this.members.push(contactOpt.value);
         }
         contactOpt.value = [];
      }
   }

   deleteMember(member: any) {
      const index: number = this.members.indexOf(member);
      if (index !== -1) {
         if (!this.isAddGroup) {
            this.flagEdit = true;
            this.service.deleteMemberGroup(this.rowgroup.id, member.id)
               .subscribe();
         }
         this.members.splice(index, 1);
      }
   }

   addContact(permission: any, fullName: any, cost: any) {
      let pathCom;
      let siteName;
      if (this.siteName === '') {
         pathCom = window.localStorage.getItem('path_company').split('/');
         siteName = pathCom[pathCom.length - 1];
      } else {
         siteName = this.siteName;
      }
      if (this.isAddGroup) {
         const gName = fullName.nativeElement.value;
         const listMember = this.members;
         if (this.listGroup?.length > 0) {
            for (let i = 0; i < this.listGroup.length; i++) {
               if (gName.toLowerCase() === this.listGroup[i].name.toLowerCase()) {
                  this.translate.get('alert.duplicate_groupname').subscribe(s => {
                     this.errorMessage = s;
                  });
                  return;
               }
            }
         }
         if (this.isAddGroup === true) {
            this.flagSubmit = true;
            this.service.addCompanyGroup(gName, permission.selected.value, this.tin, listMember, siteName)
               .subscribe((response) => {
                  this.dialogRef.close(true);
                  this.toast.success(response);
               }, (error) => {
                  this.flagSubmit = false;
                  this.toast.success(error);
               });
         }
      }

   }

   onClose() {
      this.dialogRef.close(this.flagEdit);
   }

   validMessage(input: any) {
      const value = input.value.trim();
      if (/[ก-๛<|>\\\/:?*"%^{}[\]]/g.test(value)) {
         if (/[<|>\\\/:?*"%^{}[\]]/g.test(value)) {
            this.translate.get('alert.create_folder_errors_full').subscribe(s => {
               this.errorMessage = s;
            });
         } else {
            this.translate.get('alert.create_group_company').subscribe(s => {
               this.errorMessage = s;
            });
         }
         return;
      } else {
         this.translate.get('null').subscribe(s => {
            this.errorMessage = s;
         });
      }
   }

   clickEdit() {
      this.disabled = false;
      setTimeout(() => {
         this.fullName.nativeElement.focus();
      }, 100);
   }

   displayFn(contact?: Contact): string | undefined {
      return '';
   }

   onBlur(fullName) {
      this.errorMessage = '';
      let pathCom;
      let siteName;
      if (this.siteName === '') {
         pathCom = window.localStorage.getItem('path_company').split('/');
         siteName = pathCom[pathCom.length - 1];
      } else {
         siteName = this.siteName;
      }
      const gName = fullName.value.trim();
      let isEdit = false;
      if (this.rowgroup) {
         this.oldName = this.rowgroup.name;
         isEdit = true
      } else {
         this.oldName = '';
         isEdit = false;
      }
      if (isEdit && (gName.toLowerCase() === this.oldName.toLowerCase())) {
         this.disabled = true;
      } else {
         if (/[ก-๛<|>\\\/:?*"%^{}[\]]/g.test(gName.trim())) {
            if (/[<|>\\\/:?*"%^{}[\]]/g.test(gName.trim())) {
               this.translate.get('alert.create_folder_errors_full').subscribe(s => {
                  this.errorMessage = s;
               });
            } else if (gName === '' || gName === null) {
               this.translate.get('alert.groupInputRequired').subscribe((msg) => {
                  this.errorMessage = msg;
               });
            } else {
               this.translate.get('alert.create_group_company').subscribe(s => {
                  this.errorMessage = s;
               });
            }
            return;
         } else {
            if (gName === '' || gName === null) {
               this.translate.get('alert.groupInputRequired').subscribe((msg) => {
                  this.errorMessage = msg;
               });
            } else if (this.listGroup && this.listGroup.find((data) => data.name.toLowerCase() === gName.toLowerCase())) {
               this.translate.get('alert.duplicate_groupname').subscribe(s => {
                  this.disabled = false;
                  this.errorMessage = s;
               });
            } else {
               this.service.renameGroup(this.rowgroup.id, gName, siteName, this.tin)
                  .subscribe((response) => {
                     this.disabled = true;
                     this.rowgroup.name = gName;
                     this.flagEdit = true;
                     let group = this.listGroup.find((data) =>  data.id === this.rowgroup.id);
                     if (group) {
                        group.name = gName;
                     }
                  });
            }
         }
      }
   }
}


export class Contact {
   constructor(public id: string, public name: string, public role: string, public type: string) {
   }
}
